import ApplicationController from '../../javascript/controllers/application'

export default class extends ApplicationController {

  connect() {}

}
